import { render, staticRenderFns } from "./DocumentsDetailTable.vue?vue&type=template&id=4958f43f"
import script from "./DocumentsDetailTable.vue?vue&type=script&lang=js"
export * from "./DocumentsDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports